import { hover } from 'src/components/utils';
import styled, { css } from 'styled-components';

export const Container = styled.li<{
  $isRTL?: boolean;
  $isSingleColumn?: boolean;
}>(
  ({ theme, $isRTL, $isSingleColumn }) => css`
    align-items: center;
    display: ${$isRTL && $isSingleColumn ? 'flex' : 'grid'};
    grid-template-columns: 4fr 4fr 1fr;
    border-bottom: ${theme.bo.thinWidth} solid ${theme.co.neutral95};
    padding: ${theme.sz.s3} 0;
    min-width: inherit;
    gap: ${theme.sz.s2};

    &:last-child {
      border-bottom: none;
    }

    @media (max-width: ${theme.sz.m}) {
      display: flex;
    }
  `,
);

export const WordInfo = styled.div(
  ({ theme }) => css`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s1};
  `,
);

export const TargetWord = styled.span(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.xs};
    color: ${theme.co.secondary0};
    display: flex;
    align-items: center;
    text-align: start;

    @media (max-width: ${theme.sz.m}) {
      ${theme.typography.heading.mobile.xs};
    }
  `,
);

export const SourceColumn = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s1};
  `,
);

export const SourceWord = styled.span<{ $isSmall?: boolean }>(
  ({ theme, $isSmall }) => css`
    ${$isSmall ? theme.typography.paragraph.s : theme.typography.paragraph.base};
    color: ${theme.co.secondary50};
    display: flex;
    align-items: center;

    @media (max-width: ${theme.sz.m}) {
      ${theme.typography.paragraph.s};
    }
  `,
);

export const Actions = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s2};
    justify-content: end;
    min-height: ${theme.sz.s10};
  `,
);

export const TargetImage = styled.img(
  () => css`
    max-height: 3rem;
    max-width: 100%;
    object-fit: contain;
  `,
);

export const AudioButton = styled.button<{
  $isPlaying?: boolean;
}>(
  ({ theme, $isPlaying }) => css`
    padding: ${theme.sz.s1};
    background: none;
    border: none;
    border-radius: ${theme.bo.round};
    cursor: pointer;
    font-size: ${theme.sz.s6};
    display: flex;
    align-items: center;
    justify-content: center;

    ${
      $isPlaying &&
      css`
        background-color: ${theme.co.primary95};
      `
    }

    &:hover {
      background-color: ${hover(theme.co.neutral98)};
    }
  `,
);
